import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { imageAddressPrefix } from 'spec';

const Error401 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Helmet title={t('errors.error401.title')} />
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <Grid item mt="179px">
          <img
            src={`${imageAddressPrefix}static/img/errors/error401.svg`}
            alt="Error401"
          />
        </Grid>
        <Grid item mt="28px">
          <Typography variant="h2Heavy">
            {t('errors.error401.pageNotAccessible')}
            <Typography
              variant="h1Heavy"
              sx={{ color: theme.icon.errorPageExclamationSign.color }}
            >
              !
            </Typography>
          </Typography>
        </Grid>
        <Grid item mt="16px">
          <Typography variant="h5Bold">
            {t('errors.error401.noAccess')}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Error401;
